import { createContext, useContext, useEffect, useState } from 'react'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, 
    signOut, onAuthStateChanged, updateProfile} from 'firebase/auth'
import { auth } from '../firebase-config'
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

const UserContext = createContext()
const storage = getStorage();

export function UserAuth() {
    return useContext(UserContext);
}

export const AuthContextProvider = ({ children }) => { 

    const [currentUser, setUser] = useState();
    const [loading, setLoading] = useState(true);

    const createUser = (email, password) => {
        return createUserWithEmailAndPassword(auth, email, password);
    };

    const signIn = (email, password) => {
        signInWithEmailAndPassword(auth, email, password);
    }

    const logout = () => {
        return signOut(auth)
    };
    
    useEffect(() => {
        setLoading(true);
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            console.log(user);
            setUser(user);
            setLoading(false);
        });
        return () => { 
            unsubscribe(); 
        };
    }, []);


    return (
        <UserContext.Provider value={{ createUser, loading, currentUser, logout, signIn }}>
            { !loading && children }
        </UserContext.Provider>
    )
}

// Profile Picture
export async function upload(file, currentUser, setLoading) {
    const fileRef = ref(storage, currentUser.uid + '.png');
    console.log(currentUser.uid)
    setLoading(true)
    const snapshot = await uploadBytes(fileRef, file);
    const photoURL = await getDownloadURL(fileRef);
    updateProfile(currentUser, {photoURL});
    setLoading(false);
    window.location.reload();
  }